<template>
  <div>
    <NavBarAdmin></NavBarAdmin>
    <h3 class="mt-3">Nueva forma para la línea perfiles metálicos</h3>
    <ImgForm></ImgForm>
    <FooterAdmin></FooterAdmin>
  </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue";
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue";
import ImgForm from "@/components/Admin/Profile/NewImgProfileFormComponent.vue"
export default {
  components: {
    NavBarAdmin,
    FooterAdmin,
    ImgForm,
  },
};
</script>
<style></style>